module.exports = __webpack_public_path__ + "media/images/one-b9370dbf81461c6aa7cc2cf3c6404e75.jpg";